import { add_to_version_info as $4uUHR$add_to_version_info, dlog as $4uUHR$dlog, derror as $4uUHR$derror, depict_click as $4uUHR$depict_click, foolproof_send_beacon as $4uUHR$foolproof_send_beacon, base_url as $4uUHR$base_url, observer as $4uUHR$observer, instant_exec_on_suspect_history_change as $4uUHR$instant_exec_on_suspect_history_change, catchify as $4uUHR$catchify, get_session_id as $4uUHR$get_session_id, get_tracking_event_context_data as $4uUHR$get_tracking_event_context_data, send_depict_unfiltered as $4uUHR$send_depict_unfiltered } from "@depict-ai/utilishared/ES10";
import $4uUHR$babelruntimehelpersdefineProperty from "@babel/runtime/helpers/defineProperty";
import $4uUHR$babelruntimehelpersclassPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import $4uUHR$babelruntimehelpersclassPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";

/*! Depict PerformanceClient */
import { register_es_version } from "../multi_import_deduplicator.mjs";
register_es_version("performance-client", "ES10");
const $3242b911de3d57ad$export$83d89fbfd8236492 = "2.6.0";
let $983195e3c4979825$export$8ae64f3d447c14f7;
(function (ProductCardType) {
  ProductCardType[ProductCardType["Recommendation"] = 0] = "Recommendation";
  ProductCardType[ProductCardType["SnakeRecommendation"] = 1] = "SnakeRecommendation";
  ProductCardType[ProductCardType["SearchResult"] = 2] = "SearchResult";
  ProductCardType[ProductCardType["ProductListingResult"] = 3] = "ProductListingResult";
})($983195e3c4979825$export$8ae64f3d447c14f7 || ($983195e3c4979825$export$8ae64f3d447c14f7 = {}));
const $983195e3c4979825$export$7c03f17546479d1d = {
  [$983195e3c4979825$export$8ae64f3d447c14f7.Recommendation]: "recommendation_id",
  [$983195e3c4979825$export$8ae64f3d447c14f7.SnakeRecommendation]: "recommendation_id",
  [$983195e3c4979825$export$8ae64f3d447c14f7.SearchResult]: "search_result_id",
  [$983195e3c4979825$export$8ae64f3d447c14f7.ProductListingResult]: "product_listing_result_id"
}; /**
   * The Depict Queue function used to register events to be sent to depict.
   */ /**
      * Depict Object containing everything depict-related on the page.
      */ /**
         * Purchase format used by GA4 when sending a purchase event.
         * See https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#make_a_purchase_or_issue_a_refund
         */ /**
            * Product format used by GA4 when sending a purchase event.
            * See https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase_item
            */

const $0cf01531cdd5b1ae$export$6f11e212918dbb31 = ".depict-add-to-cart";
const $0cf01531cdd5b1ae$export$79f7900b4eea40cf = {
  // We sadly have customers in the wild using both _ and -
  "data-recommendation_id": (0, $983195e3c4979825$export$8ae64f3d447c14f7).SnakeRecommendation,
  "data-recommendation-id": (0, $983195e3c4979825$export$8ae64f3d447c14f7).Recommendation,
  // All of these product cards are Depict rendered via js or react ui, so we know the data attribute
  "data-search-result-id": (0, $983195e3c4979825$export$8ae64f3d447c14f7).SearchResult,
  "data-product-listing-result-id": (0, $983195e3c4979825$export$8ae64f3d447c14f7).ProductListingResult
};

/**
 * Creates an event queue (depict queue)
 */
function $f06bf37f1e6136a4$var$create_dpq() {
  const fn = function () {
    const args = arguments;
    if (fn.send_event) fn.send_event.apply(this, args);else fn.queue.push(args);
  };
  fn.queue = [];
  return fn;
}
const $f06bf37f1e6136a4$var$string_guard = (eventName, eventData) => {
  if (typeof eventData == "number" && !isNaN(eventData)) return eventData.toString();
  if (typeof eventData !== "string") throw new Error("".concat(eventName, " event requires a string as an argument"));
  return eventData;
};
const $f06bf37f1e6136a4$var$nullable_undefined_string_guard = (eventName, eventData) => {
  if (eventData === null || eventData === undefined) return eventData;
  return $f06bf37f1e6136a4$var$string_guard(eventName, eventData);
};
const $f06bf37f1e6136a4$var$ga4_purchase_guard = purchaseEvent => {
  if (typeof purchaseEvent !== "object" || purchaseEvent === null) throw new Error("purchase event requires an object as an argument");
  if (!Array.isArray(purchaseEvent.items)) throw new Error("purchase event requires an items array of purchased products");else if (!purchaseEvent.currency || typeof purchaseEvent.currency !== "string") throw new Error("purchase event requires a currency string");else if (!purchaseEvent.transaction_id || !(typeof purchaseEvent.transaction_id == "string" || typeof purchaseEvent.transaction_id == "number")) throw new Error("purchase event requires a transaction_id string");
  // Transaction id could be either number or string at this point, automatically convert the latter
  purchaseEvent.transaction_id = purchaseEvent.transaction_id.toString();
  for (const item of purchaseEvent.items) {
    if (item.item_id == "" || !(typeof item.item_id == "string" || typeof item.item_id == "number" && !isNaN(item.item_id))) throw new Error("purchased item requires an item_id of the purchased product");else if (isNaN(item.price))
      // ^ 0 cost items are valid
      throw new Error("purchase item requires a unit price for the product purchased");else if (!item.quantity || isNaN(item.quantity))
      // ^ But 0 quantity items are not
      throw new Error("purchase item requires a quantity of products purchased");
    // Item id could be either number or string at this point, automatically convert the latter
    item.item_id = item.item_id.toString();
  }
  return true;
};
/**
 * Handle events from dpq with the global dpc instance.
 */
const $f06bf37f1e6136a4$var$event_handler = (dpc, eventName, eventData) => {
  // take passed DPC since the window.depict object might have been overridden
  if (eventName === "purchase") {
    if (!$f06bf37f1e6136a4$var$ga4_purchase_guard(eventData))
      // Inaccessible since ga4_purchase_guard will throw an error, TS doesn't know that
      return;
    dpc.sendPurchaseEvent(eventData);
    return;
  }
  // All events below require strings as argument, accept numbers and automatically convert them
  if (typeof eventData == "number") eventData = eventData.toString();
  if (eventName === "addToCart") dpc.sendAddToCartEvent({
    product_id: $f06bf37f1e6136a4$var$string_guard(eventName, eventData)
  });else if (eventName === "setMarket") dpc.setMarket($f06bf37f1e6136a4$var$string_guard(eventName, eventData));else if (eventName === "setProductId") dpc.setProductId($f06bf37f1e6136a4$var$string_guard(eventName, eventData));else if (eventName === "setSessionId") dpc.setSessionId($f06bf37f1e6136a4$var$nullable_undefined_string_guard(eventName, eventData));
};
const $f06bf37f1e6136a4$export$7a1bb429756ced60 = dpc => {
  var _window, _window2;
  const dpq = (_window = window).dpq || (_window.dpq = $f06bf37f1e6136a4$var$create_dpq());
  const depict = (_window2 = window).depict || (_window2.depict = {});
  depict.dpq = dpq; // refrencing dpq into the depict object
  depict.eventHistory = dpq.queue; // making this more visible in the depict object
  depict.dpc = dpc;
  // Hook up the depict queue to the PerformanceClient
  if (!dpq.send_event) {
    dpq.send_event = (eventName, eventData) => {
      dpq.queue.push([eventName, eventData]); // push to queue as usual to keep history
      $f06bf37f1e6136a4$var$event_handler(dpc, eventName, eventData); // hand-over to the PerformanceClient
    };
    // Handle any events queued before this code ran.
    dpq.queue.forEach(_ref => {
      let [eventName, eventData] = _ref;
      $f06bf37f1e6136a4$var$event_handler(dpc, eventName, eventData);
    });
  }
};
function $53af71a3700e1e90$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $53af71a3700e1e90$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $53af71a3700e1e90$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $53af71a3700e1e90$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $53af71a3700e1e90$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $53af71a3700e1e90$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
var $53af71a3700e1e90$var$_has_sent_pageview_for_current_href = /*#__PURE__*/new WeakMap();
var $53af71a3700e1e90$var$_resetSentPageViewForCurrentHref = /*#__PURE__*/new WeakSet();
var $53af71a3700e1e90$var$_parseOptions = /*#__PURE__*/new WeakSet();
var $53af71a3700e1e90$var$_getContextData = /*#__PURE__*/new WeakSet();
var $53af71a3700e1e90$var$_sendTrackingEvent = /*#__PURE__*/new WeakSet();
var $53af71a3700e1e90$var$_getProductId = /*#__PURE__*/new WeakSet();
class $53af71a3700e1e90$export$820526014323765f {
  /** Latest product_id found in the DOM. Used in a2c & pageview events on PDPs. */ /** The value of location.pathname when latest_product_id was set  */ /** Latest session_id set on the client. Used for all events. */ /** if we've sent a page view event for the current href */constructor(merchant, _options) {
    var _window$depict;
    $53af71a3700e1e90$var$_classPrivateMethodInitSpec(this, $53af71a3700e1e90$var$_getProductId);
    $53af71a3700e1e90$var$_classPrivateMethodInitSpec(this, $53af71a3700e1e90$var$_sendTrackingEvent);
    $53af71a3700e1e90$var$_classPrivateMethodInitSpec(this, $53af71a3700e1e90$var$_getContextData);
    $53af71a3700e1e90$var$_classPrivateMethodInitSpec(this, $53af71a3700e1e90$var$_parseOptions);
    $53af71a3700e1e90$var$_classPrivateMethodInitSpec(this, $53af71a3700e1e90$var$_resetSentPageViewForCurrentHref);
    $4uUHR$babelruntimehelpersdefineProperty(this, "merchant", void 0);
    $4uUHR$babelruntimehelpersdefineProperty(this, "auto_observe", true);
    $4uUHR$babelruntimehelpersdefineProperty(this, "market", void 0);
    $4uUHR$babelruntimehelpersdefineProperty(this, "latest_product_id", void 0);
    $4uUHR$babelruntimehelpersdefineProperty(this, "latest_product_id_path", void 0);
    $4uUHR$babelruntimehelpersdefineProperty(this, "latest_session_id", void 0);
    $53af71a3700e1e90$var$_classPrivateFieldInitSpec(this, $53af71a3700e1e90$var$_has_sent_pageview_for_current_href, {
      writable: true,
      value: false
    });
    $4uUHR$babelruntimehelpersdefineProperty(this, "tracked_elements", new WeakSet());
    // Make sure we do not construct dpc more than once.
    if (((_window$depict = window.depict) === null || _window$depict === void 0 ? void 0 : _window$depict.dpc) instanceof $53af71a3700e1e90$export$820526014323765f) {
      $4uUHR$dlog("DPC already initialized. Returning existing instance.");
      return window.depict.dpc;
    }
    $f06bf37f1e6136a4$export$7a1bb429756ced60(this);
    this.merchant = merchant;
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_parseOptions, $53af71a3700e1e90$var$_parseOptions2).call(this, _options);
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_resetSentPageViewForCurrentHref, $53af71a3700e1e90$var$_resetSentPageViewForCurrentHref2).call(this);
    if (this.auto_observe) {
      this.observeRecommendations();
      this.observePDPA2CButton();
    }
  }
  /**
  * Make sure the tracking is not set up twice on the same element.
  */
  checkIfTracked(element) {
    if (this.tracked_elements.has(element)) {
      $4uUHR$dlog("Already tracked", element);
      return true;
    }
    this.tracked_elements.add(element);
    return false;
  }
  /**
  * Adds click and impression tracking to a product card
  */
  trackProductCard(card, tracking_id, type) {
    if (this.checkIfTracked(card)) return;
    switch (type) {
      case (0, $983195e3c4979825$export$8ae64f3d447c14f7).Recommendation:
      case (0, $983195e3c4979825$export$8ae64f3d447c14f7).SnakeRecommendation:
        card.addEventListener("click", () => this.sendRecommendationClickEvent(tracking_id));
        break;
      case (0, $983195e3c4979825$export$8ae64f3d447c14f7).SearchResult:
        card.addEventListener("click", () => this.sendSearchResultClickEvent(tracking_id));
        break;
      case (0, $983195e3c4979825$export$8ae64f3d447c14f7).ProductListingResult:
        card.addEventListener("click", () => this.sendProductListingResultClickEvent(tracking_id));
        break;
    }
    // If the card has optional a2c buttons, we track those as well.
    const a2c_buttons = card.querySelectorAll((0, $0cf01531cdd5b1ae$export$6f11e212918dbb31));
    for (const a2c_button of a2c_buttons) this.trackAddToCartButton(a2c_button, card);
  }
  /**
  * Adds tracking to an Add to cart button.
  */
  trackAddToCartButton(button, productCard) {
    if (this.checkIfTracked(button)) return;
    button.addEventListener("click", () => {
      if (!productCard) {
        // If the button is not nested in a product card, it's a PDP button. Product ID set on the page is required.
        const product_id = $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getProductId, $53af71a3700e1e90$var$_getProductId2).call(this);
        if (!product_id) {
          $4uUHR$derror("No product ID set for add-to-cart click outside of product card", button);
          return;
        }
        this.sendAddToCartEvent({
          product_id: product_id
        });
        return;
      }
      // If the button is nested in a product card, we need to find the tracking ID. It can set in one of several attributes.
      for (const [attribute, type] of Object.entries((0, $0cf01531cdd5b1ae$export$79f7900b4eea40cf))) {
        const tracking_id = productCard.getAttribute(attribute);
        if (!tracking_id) continue;
        const tracking_data = {
          [(0, $983195e3c4979825$export$7c03f17546479d1d)[type]]: tracking_id
        };
        this.sendAddToCartEvent(tracking_data);
        return;
      }
      $4uUHR$derror("Could not find tracking data for add-to-cart click on button", button);
    });
  }
  /**
  * Sends a tracking event to depict
  */ /**
     * Sends an Add to Cart Event to depict
     * If the add to cart unmistakably happened due to a click on a product card shown because of Depict (for example the add to cart button on a product card), set recommendation_id / search_result_id / product_listing_result_id (whatever applicable). If it happened on a PDP, set product_id instead.
     */
  sendAddToCartEvent(data) {
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_sendTrackingEvent, $53af71a3700e1e90$var$_sendTrackingEvent2).call(this, {
      type: "add_to_cart",
      ...data
    });
  }
  /**
  * Sends a recommendation impression event to Depict
  */
  sendRecommendationImpressionEvent(recommendation_id) {
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_sendTrackingEvent, $53af71a3700e1e90$var$_sendTrackingEvent2).call(this, {
      type: "element_visible",
      recommendation_id: recommendation_id
    });
  }
  /**
  * Sends a search result impression event to Depict
  */
  sendSearchResultImpressionEvent(search_result_id) {
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_sendTrackingEvent, $53af71a3700e1e90$var$_sendTrackingEvent2).call(this, {
      type: "element_visible",
      search_result_id: search_result_id
    });
  }
  /**
  * Sends a product listing result impression event to Depict
  */
  sendProductListingResultImpressionEvent(product_listing_result_id) {
    $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_sendTrackingEvent, $53af71a3700e1e90$var$_sendTrackingEvent2).call(this, {
      type: "element_visible",
      product_listing_result_id: product_listing_result_id
    });
  }
  /**
  * Sends a recommendation click event to Depict
  */
  sendRecommendationClickEvent(recommendation_id) {
    $4uUHR$depict_click({
      recommendation_id: recommendation_id,
      ...$53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getContextData, $53af71a3700e1e90$var$_getContextData2).call(this)
    });
  }
  /**
  * Sends a search result click event to Depict
  */
  sendSearchResultClickEvent(search_result_id) {
    $4uUHR$depict_click({
      search_result_id: search_result_id,
      ...$53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getContextData, $53af71a3700e1e90$var$_getContextData2).call(this)
    });
  }
  /**
  * Sends a product listing result click event to Depict
  */
  sendProductListingResultClickEvent(product_listing_result_id) {
    $4uUHR$depict_click({
      product_listing_result_id: product_listing_result_id,
      ...$53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getContextData, $53af71a3700e1e90$var$_getContextData2).call(this)
    });
  }
  /**
  * Sends a Purchase Event to Depict
  */
  sendPurchaseEvent(data) {
    if (!this.market) throw Error("Market not set");
    const {
      session_id: session_id
    } = $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getContextData, $53af71a3700e1e90$var$_getContextData2).call(this);
    const items = data.items.map(item => ({
      sku: item.item_id,
      price: item.price,
      quantity: item.quantity
    }));
    const request = {
      events: [{
        event_type: "purchase",
        session_id: session_id,
        transaction_id: data.transaction_id,
        currency: data.currency,
        // This "At least one item" interface is too cumbersome to expose to end users, they get a plain array typing instead.
        products: items
      }],
      tenant: this.merchant,
      market: this.market
    };
    $4uUHR$foolproof_send_beacon((0, $4uUHR$base_url) + "/v2/create-events", request);
  }
  /**
  * Update the market used for tracking events
  */
  setMarket(market) {
    this.market = market;
  }
  /**
  * Update the product_id used for add-to-cart and pageview events on PDPs.
  */
  setProductId(product_id) {
    $4uUHR$dlog("Setting product id", product_id);
    this.latest_product_id = product_id;
    this.latest_product_id_path = location.pathname;
    if (!$4uUHR$babelruntimehelpersclassPrivateFieldGet(this, $53af71a3700e1e90$var$_has_sent_pageview_for_current_href)) {
      $53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_sendTrackingEvent, $53af71a3700e1e90$var$_sendTrackingEvent2).call(this, {
        type: "page_view",
        product_id: product_id
      });
      $4uUHR$babelruntimehelpersclassPrivateFieldSet(this, $53af71a3700e1e90$var$_has_sent_pageview_for_current_href, true);
    }
  }
  /**
  * Set the current session_id.
  *
  * https://docs.depict.ai/docs/performance-client#browser-sessions
  */
  setSessionId(session_id) {
    $4uUHR$dlog("Setting session id", session_id);
    this.latest_session_id = session_id || undefined;
  }
  /**
  * Observe the DOM for recommendations to track
  */
  observeRecommendations() {
    for (const [attribute, type] of Object.entries((0, $0cf01531cdd5b1ae$export$79f7900b4eea40cf))) {
      const selector = "[".concat(attribute, "]");
      $4uUHR$dlog("Starting to observe product cards with selector", selector);
      (0, $4uUHR$observer).onexists(selector, _ref => {
        let {
          element: element
        } = _ref;
        const tracking_id = element.getAttribute(attribute);
        if (!tracking_id) {
          $4uUHR$derror("No tracking id found on element with attribute ".concat(selector), element);
          return;
        }
        this.trackProductCard(element, tracking_id, type);
      });
    }
  }
  /**
  * Observe the dom for add to cart buttons. Used on product detail pages.
  */
  observePDPA2CButton() {
    const handler = _ref2 => {
      let {
        element: element
      } = _ref2;
      const depict_card_selector = Object.keys((0, $0cf01531cdd5b1ae$export$79f7900b4eea40cf)).map(attribute => "[".concat(attribute, "]")).join(",");
      // it's an add to cart button on a product card that possibly was added to the product card at a later point, if parent_depict_card is defined
      const parent_depict_card = element.closest(depict_card_selector) || undefined;
      $4uUHR$dlog("Found ".concat(parent_depict_card ? "product card" : "pdp", " add-to-cart button"), element);
      this.trackAddToCartButton(element, parent_depict_card);
    };
    (0, $4uUHR$observer).onexists((0, $0cf01531cdd5b1ae$export$6f11e212918dbb31), handler);
  }
}
function $53af71a3700e1e90$var$_resetSentPageViewForCurrentHref2() {
  let url = location.href;
  (0, $4uUHR$instant_exec_on_suspect_history_change).add($4uUHR$catchify(() => {
    const {
      href: new_href
    } = location;
    if (url !== new_href) {
      $4uUHR$babelruntimehelpersclassPrivateFieldSet(this, $53af71a3700e1e90$var$_has_sent_pageview_for_current_href, false);
      url = new_href;
    }
  }));
}
function $53af71a3700e1e90$var$_parseOptions2(options) {
  if (options !== undefined) {
    if (options.auto_observe !== undefined) this.auto_observe = options.auto_observe;
    if (options.market !== undefined) this.market = options.market;
  }
}
function $53af71a3700e1e90$var$_getContextData2() {
  const data = {
    market: this.market,
    tenant: this.merchant,
    session_id: this.latest_session_id || $4uUHR$get_session_id()
  };
  return {
    ...$4uUHR$get_tracking_event_context_data(),
    ...data
  };
}
function $53af71a3700e1e90$var$_sendTrackingEvent2(payload) {
  // Todo. check consent. For some events, delay until consent decision, with possible timeout.
  // For others, decide immediately based on current consent. (We shouldn't track a long history of events from before the user consented)
  // If no consent, don't send at all, or send anonymous? I think the latter is valid, since no ID in cookie or localStorage.
  $4uUHR$send_depict_unfiltered([{
    ...payload,
    ...$53af71a3700e1e90$var$_classPrivateMethodGet(this, $53af71a3700e1e90$var$_getContextData, $53af71a3700e1e90$var$_getContextData2).call(this)
  }], true);
}
function $53af71a3700e1e90$var$_getProductId2() {
  if (this.latest_product_id_path !== location.pathname) return undefined;
  return this.latest_product_id;
}
$4uUHR$add_to_version_info("dpc", (0, $3242b911de3d57ad$export$83d89fbfd8236492));
export { $53af71a3700e1e90$export$820526014323765f as DPC, $3242b911de3d57ad$export$83d89fbfd8236492 as version };